export default class Carousel {
    constructor() {
        this.element = '[data-carousel]';
        this.logosListSelector = '.carousel__logos-list';
        this.logoWrapperSelector = '.carousel__logo-wrapper';
        this.nextButtonSelector = '.carousel__next';
        this.previousButtonSelector = '.carousel__prev';
        this.swappingImages = false;
        this.init();
    }

    init() {
        // early exit
        const self = document.querySelector(this.element);
        if (!self) {
            return false;
        }
        const prevButton = document.querySelector(this.previousButtonSelector);
        const nextButton = document.querySelector(this.nextButtonSelector);
        prevButton.addEventListener('click', () => {
            this.moveRight();
        });
        nextButton.addEventListener('click', () => {
            this.moveLeft();
        });
    }

    moveLeft() {
        const carouselLogos = document.querySelectorAll(this.logoWrapperSelector);
        const [head, ...tail] = carouselLogos;
        this.refreshList([...tail, head]);
    }

    moveRight() {
        if (!this.swappingImages) {
            this.swappingImages = true;
            const carouselLogos = document.querySelectorAll(this.logoWrapperSelector);
            const reverseOrderImages = [];
            for (let i = carouselLogos.length - 1, j = 0; i >= 0; i--, j++) {
                reverseOrderImages[j] = carouselLogos[i];
            }
            const [head, ...tail] = reverseOrderImages;
            this.refreshList([...tail, head].reverse());
        }
        this.swappingImages = false;
    }

    refreshList(list) {
        const logosList = document.querySelector(this.logosListSelector);
        logosList.textContent = '';
        Array.prototype.forEach.call(list, listItem => logosList.appendChild(listItem));
        const displayStyle = logosList.style.display;
        setTimeout(() => {
            logosList.style.display = 'none';
            logosList.style.display = displayStyle;
        }, 100);
    }
}
